// ═══════════════════════════════════════════════════════════════════════════
// POPUP RULES — metadata thuần của từng popup entry (id, thứ tự, tần suất).
//
// File này CỐ Ý không import gì cả: popupManager.js cần đọc nó, mà popupManager
// lại được import từ ModalLogin/LoginMobile/LayoutApp. Nếu để chung với phần
// render (popupRegistry.jsx — file có import component) sẽ tạo circular import
// popupManager → registry → PopupIntro → ... → ModalLogin → popupManager.
//
// Phần điều kiện hiển thị (isEligible) và phần render nằm ở popupRegistry.jsx,
// ghép với file này theo `id`. popupRegistry.jsx có assert 2 danh sách khớp
// nhau nên quên khai báo 1 bên sẽ báo lỗi ngay khi dev, không âm thầm bỏ qua.
//
// Thêm popup : thêm 1 object ở đây + 1 entry cùng id ở popupRegistry.jsx.
// Gỡ popup   : xoá ở cả 2 nơi (và xoá key localStorage pm_freq_<id> nếu cần).
// Đổi thứ tự : sửa `priority` (nhỏ = ưu tiên cao).
// ═══════════════════════════════════════════════════════════════════════════

// ─── Cờ bật/tắt popup ────────────────────────────────────────────────────────
// Đây là chỗ DUY NHẤT cần sửa để bật/tắt một popup.
export const POPUP_ENABLED = {
  // pu5 = cờ EVENT do FE tự dựng. Đang không dùng (rule pu5 bên dưới comment),
  // CTKM priority 1 hiện là popup CMS pu6. Giữ cờ để mở lại khi cần.
  pu5: false,
  pu8: true,
  pu9: true,
  pu3: true,
  pu10: true,
  pu2: true,
  pu7: true,
  pu6: true,
};

// ─── Cấu hình từng popup ─────────────────────────────────────────────────────
//   id         string   — khoá bền vững, dùng làm key localStorage pm_freq_<id>
//   priority   number   — nhỏ = ưu tiên cao (theo bảng spec)
//   frequency  'daily' | 'weekly' | 'always'
//   scope      'user' | 'device' — 'user' thì hạn mức tần suất tính riêng từng
//                                  tài khoản (dùng chung máy không đè nhau)
//   enabled    boolean  — lấy từ POPUP_ENABLED
//   guest      boolean  — true = guest (chưa đăng nhập) cũng thấy popup này.
//                         Không khai báo = chỉ user đã login.
//
// Nguồn yêu cầu: sheet "Phân nhóm và tối ưu luồng người dùng" (BA) trong
// src/Mytel - ShweDeal - SHWEDEAL 2.0 UPGRADE.xlsx.
// Thứ tự theo spec "2a. User đã login". Spec "2b. Guest" chỉ gồm CTKM (pu6) →
// pu2 → pu7, đúng thứ tự tương đối trong danh sách này nên dùng chung, không cần
// bảng priority riêng. Tần suất của guest tự tính theo thiết bị: không có userId
// thì freqKey() trong popupManager.js dùng key pm_freq_<id> chung cho cả máy.
export const POPUP_RULES = [
  // pu5 — popup event do FE tự dựng. Đang comment: vai trò "Mời tham gia CTKM"
  // (priority 1 của spec) hiện do popup CMS pu6 đảm nhận. Mở lại pu5 thì phải
  // chốt lại với BA thứ tự giữa pu5 và pu6 — spec chỉ có MỘT popup CTKM.
  // {
  //   id: "pu5",
  //   priority: 1,
  //   frequency: "daily",
  //   scope: "user",
  //   enabled: POPUP_ENABLED.pu5,
  //   guest: true,
  // },
  // Priority 1 — Mời tham gia CTKM (popup CMS, Marketing → Popup)
  // Đối tượng: tất cả user login vào dịch vụ trong thời gian diễn ra sự kiện, và
  // mọi guest — khi /front/product/popup có popup đang trong start_time..end_time.
  // Hiển thị lần lượt theo `position`, mỗi ngày tiến 1 vị trí (API đã ORDER BY
  // POSITION ASC). API không cần auth nên guest gọi được.
  // Tần suất 'always' ở mức engine để popup không bao giờ bị loại khỏi ứng viên
  // — hạn mức thật "1 lần/ngày" (guest: 1 lần/ngày/thiết bị) nằm ở isEligible
  // của pu6 (popupRegistry.jsx). Để 'daily' thì hiện 1 lần là cả ngày không
  // fetch nữa. API được gọi lại ở MỌI lần tải trang, kể cả khi global gate
  // đang chặn (xem fetchOnEveryLoad trong popupRegistry.jsx).
  {
    id: "pu6",
    priority: 1,
    frequency: "always",
    scope: "device",
    enabled: POPUP_ENABLED.pu6,
    guest: true,
  },

  // Priority 2 — Đổi mật khẩu
  // Đối tượng: user chưa từng đặt mật khẩu
  {
    id: "pu8",
    priority: 2,
    frequency: "weekly",
    scope: "user",
    enabled: POPUP_ENABLED.pu8,
  },

  // Priority 3 — Cảnh báo mất chuỗi (POP-01 nghỉ 1 ngày / POP-02 nghỉ 2 ngày)
  // Đối tượng: login-streak/status có day_off = 1 hoặc 2. Nghỉ từ 3 ngày thì
  // không hiện. Chuỗi đã reset/đã hồi sinh thì day_off về 0 nên tự loại.
  // "Chỉ có hiệu lực trong ngày user quay lại": daily + day_off chỉ > 0 trong
  // ngày đó (hồi sinh hoặc sang ngày khác thì day_off đổi).
  {
    id: "pu9",
    priority: 3,
    frequency: "daily",
    scope: "user",
    enabled: POPUP_ENABLED.pu9,
  },

  // Priority 4 — Tặng Free Turn 7 ngày đầu
  // Đối tượng: userInfo.isReceivedFreeBidToday === true (/front/user/current)
  {
    id: "pu3",
    priority: 4,
    frequency: "daily",
    scope: "user",
    enabled: POPUP_ENABLED.pu3,
  },

  // Priority 5 — Chúc mừng thăng hạng Shwe Master
  // Đối tượng: user-rank/status có show_congrats_popup === true và hiện vẫn là
  // MASTER (tụt hạng trước khi xem thì tự huỷ).
  // Tần suất "đúng 1 lần mỗi lần thăng hạng" do cờ của BE quyết định, nên để
  // 'always' — popupRegistry.jsx tự chặn hiện lại trong cùng một lần thăng hạng.
  {
    id: "pu10",
    priority: 5,
    frequency: "always",
    scope: "user",
    enabled: POPUP_ENABLED.pu10,
  },

  // Priority 6 — Winner tuần / Non-winner
  // Đối tượng: user không thuộc nhóm winner của tuần
  // Guest: mọi guest, 1 lần/tuần/thiết bị.
  {
    id: "pu2",
    priority: 6,
    frequency: "weekly",
    scope: "device",
    enabled: POPUP_ENABLED.pu2,
    guest: true,
  },

  // Priority 7 — Mời tham gia Minigame
  // Đối tượng: configMiniGame.is_show === 1 (/front/mini-game/get-mini-game).
  // Spec: mọi user đã login, kể cả user đã chơi Minigame trong ngày.
  // Guest: mọi guest, 1 lần/ngày/thiết bị.
  {
    id: "pu7",
    priority: 7,
    frequency: "daily",
    scope: "user",
    enabled: POPUP_ENABLED.pu7,
    guest: true,
  },

  // Popup mời bắt đầu tour hướng dẫn (trước đây là pu4) KHÔNG nằm ở đây: nó là
  // luồng dành cho người mới, chạy ngoài popup manager —
  // component/NewUserTourInvite.jsx + utils/introTour.js.
];

// Tra cứu nhanh theo id.
export const POPUP_RULE_BY_ID = new Map(POPUP_RULES.map((r) => [r.id, r]));

// Map tên hằng → id, giữ tương thích với cách gọi POPUP_ID.PU2 sẵn có.
export const POPUP_ID = POPUP_RULES.reduce((acc, r) => {
  acc[r.id.toUpperCase()] = r.id;
  return acc;
}, {});
